import useEntriesReceiptData from "@app/data-hooks/use-entries-receipt-data.ts";
import { Box, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Dialog, QueryStatusRouter } from "bi-lib";
import { useMemo } from "react";

interface Props {
    id?: string;
    open: boolean;
    onClose: () => void;
}

export default function ViewReceiptModal({ id, open, onClose }: Props) {
    const { entryReceipt, deleteReceipt } = useEntriesReceiptData({ id: open ? id : undefined });

    const isPdf = useMemo(() => {
        if (entryReceipt.data == undefined) {
            return undefined;
        }
        return entryReceipt.data.toLowerCase().endsWith(".pdf");
    }, [entryReceipt.data]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"xl"} fullWidth>
            <DialogTitle>View Receipt</DialogTitle>
            <DialogContent>
                <QueryStatusRouter queryHook={entryReceipt}>
                    {entryReceipt.data != undefined && (
                        <Box display={"flex"} justifyContent={"center"}>
                            {isPdf ? (
                                <iframe
                                    src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${entryReceipt.data}#toolbar=0&scrollbar=0"`}
                                    frameBorder={0}
                                    scrolling={"auto"}
                                    width="100%"
                                    style={{ height: "80vh" }}
                                />
                            ) : (
                                <img src={entryReceipt.data} alt={"Receipt"} />
                            )}
                        </Box>
                    )}
                </QueryStatusRouter>
            </DialogContent>
            <DialogActions>
                <Button
                    variant={"contained"}
                    color={"error"}
                    onClick={async () => {
                        await deleteReceipt.mutateAsync(id!);
                        onClose();
                    }}
                >
                    Delete
                </Button>
                <Button variant={"outlined"} onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
